<app-loading *ngIf="contentReady"></app-loading>

<section class="bb-page">
  <div class="bb-page-shell">

    <header class="bb-page-header">
      <div class="bb-page-title-block">
        <span class="bb-eyebrow">{{ "supplyRequest" | transloco }}</span>
        <h2 class="bb-page-title">{{ "supplyRequest" | transloco }}</h2>
      </div>
    </header>

    <form class="bb-card bb-p-20" [formGroup]="data" (ngSubmit)="onSubmit()">
      <div class="bb-form-grid">

        @if(submitted && getMissingRequiredCount() > 0) {
        <div class="bb-form-alert bb-field-full" role="alert">
          {{ 'Review the supply request data before saving' | transloco }}
          <span>
            ({{ getMissingRequiredCount() }} {{ 'required fields' | transloco }})
          </span>
        </div>
        }

        <div class="bb-field">
          <label class="bb-label" for="supplier_name">{{ 'supplier_name' | transloco }}</label>
          <input class="bb-input" type="text" id="supplier_name" formControlName="supplier_name"
            placeholder="{{ 'supplier_name' | transloco }}" [(ngModel)]="supplier_name" [ngClass]="{
              'is-invalid': data.get('supplier_name')?.touched && data.get('supplier_name')?.invalid,
              'is-valid': data.get('supplier_name')?.touched && data.get('supplier_name')?.valid
            }" />
          @if(shouldShowError('supplier_name')) {
          <div class="bb-field-error">{{ getErrorMessage('supplier_name', ('supplier_name' | transloco)) }}</div>
          }
        </div>

        <div class="bb-field">
          <label class="bb-label" for="phonenumber">{{ 'Phone Number' | transloco }}</label>
          <input class="bb-input" type="text" id="phonenumber" formControlName="phonenumber"
            placeholder="{{ 'Phone Number' | transloco }}" [(ngModel)]="phonenumber" [ngClass]="{
              'is-invalid': data.get('phonenumber')?.touched && data.get('phonenumber')?.invalid,
              'is-valid': data.get('phonenumber')?.touched && data.get('phonenumber')?.valid
            }" />
          @if(shouldShowError('phonenumber')) {
          <div class="bb-field-error">{{ getErrorMessage('phonenumber', ('Phone Number' | transloco)) }}</div>
          }
        </div>

        <div class="bb-field bb-field-full">
          <label class="bb-label">{{ 'invoice_type' | transloco }}</label>
          <div class="bb-form-grid">
            @for (el of types; track el) {
            <label class="bb-card bb-p-12 bb-flex bb-items-center bb-gap-8 bb-font-semibold" [for]="'invoice-type-' + el.id">
              <input type="radio" class="bb-checkbox" formControlName="type" [(ngModel)]="type" [value]="el.id"
                [id]="'invoice-type-' + el.id" (change)="typeChange(el.id)" [ngClass]="{
                  'is-invalid': data.get('type')?.touched && data.get('type')?.invalid,
                  'is-valid': data.get('type')?.touched && data.get('type')?.valid
                }" />
              <span>{{ isAr ? el.nameAr : el.name }}</span>
            </label>
            }
          </div>
          @if(shouldShowError('type')) {
          <div class="bb-field-error">{{ getErrorMessage('type', ('invoice_type' | transloco)) }}</div>
          }
        </div>

        @if(credit){
        <div class="bb-field">
          <label class="bb-label" for="payed">{{ 'payed' | transloco }}</label>
          <input class="bb-input" type="text" id="payed" formControlName="payed" placeholder="{{ 'payed' | transloco }}"
            [(ngModel)]="payed" [ngClass]="{
              'is-invalid': data.get('payed')?.touched && data.get('payed')?.invalid,
              'is-valid': data.get('payed')?.touched && data.get('payed')?.valid
            }" />
          @if(shouldShowConditionalError('payed')) {
          <div class="bb-field-error">{{ getErrorMessage('payed', ('payed' | transloco)) }}</div>
          }
        </div>

        <div class="bb-field">
          <label class="bb-label" for="not_payed">{{ 'not_payed' | transloco }}</label>
          <input class="bb-input" type="text" id="not_payed" formControlName="not_payed"
            placeholder="{{ 'not_payed' | transloco }}" [(ngModel)]="not_payed" [ngClass]="{
              'is-invalid': data.get('not_payed')?.touched && data.get('not_payed')?.invalid,
              'is-valid': data.get('not_payed')?.touched && data.get('not_payed')?.valid
            }" />
          @if(shouldShowConditionalError('not_payed')) {
          <div class="bb-field-error">{{ getErrorMessage('not_payed', ('not_payed' | transloco)) }}</div>
          }
        </div>
        }

        @if(installment){
        <div class="bb-field">
          <label class="bb-label" for="installment_period">{{ 'installment_period' | transloco }}</label>
          <input class="bb-input" type="text" id="installment_period" formControlName="installment_period"
            placeholder="{{ 'installment_period' | transloco }}" [(ngModel)]="installment_period" [ngClass]="{
              'is-invalid': data.get('installment_period')?.touched && data.get('installment_period')?.invalid,
              'is-valid': data.get('installment_period')?.touched && data.get('installment_period')?.valid
            }" />
          @if(shouldShowConditionalError('installment_period')) {
          <div class="bb-field-error">{{ getErrorMessage('installment_period', ('installment_period' | transloco)) }}</div>
          }
        </div>

        <div class="bb-field">
          <label class="bb-label" for="installment_price">{{ 'installment_price' | transloco }}</label>
          <input class="bb-input" type="text" id="installment_price" formControlName="installment_price"
            placeholder="{{ 'installment_price' | transloco }}" [(ngModel)]="installment_price" [ngClass]="{
              'is-invalid': data.get('installment_price')?.touched && data.get('installment_price')?.invalid,
              'is-valid': data.get('installment_price')?.touched && data.get('installment_price')?.valid
            }" />
          @if(shouldShowConditionalError('installment_price')) {
          <div class="bb-field-error">{{ getErrorMessage('installment_price', ('installment_price' | transloco)) }}</div>
          }
        </div>
        }

        <div class="bb-field bb-field-full" *ngIf="productname.length > 0">
          <div class="bb-chip-select">
            <label class="bb-label bb-chip-label">{{ 'select product' | transloco }}</label>

            <mat-form-field class="bb-chip-mat-field" appearance="outline">
              <mat-chip-grid #chipGrid class="bb-chip-grid-custom">

                <mat-chip-row *ngFor="let item of selectedProductsDetails; let i = index" (removed)="removeProduct(i)"
                  class="bb-chip-item bb-chip-item-product">
                  {{ item.product.name_ar }}

                  <button matChipRemove type="button" class="bb-chip-remove-btn">
                    X
                  </button>
                </mat-chip-row>

                <input matInput class="bb-chip-input" placeholder="{{ 'Search By product name' | transloco }}"
                  [value]="searchValue" (input)="onSearchChange($event)" [matAutocomplete]="auto"
                  [matChipInputFor]="chipGrid">

              </mat-chip-grid>
            </mat-form-field>

            @if(shouldShowProductsError()) {
            <div class="bb-field-error">{{ 'Select at least one product' | transloco }}</div>
            }
          </div>
        </div>

        @if(shouldShowProductsError() && productname.length === 0) {
        <div class="bb-field-error bb-field-full">
          {{ 'No products are available to select, or products have not loaded yet' | transloco }}
        </div>
        }

        <mat-autocomplete #auto="matAutocomplete" class="bb-chip-autocomplete-panel" (optionSelected)="addProduct($event)">
          <mat-option *ngFor="let product of filteredProviders" [value]="product">
            <div class="bb-text-stack">

              <span class="bb-product-title">
                {{product.name_ar}}
              </span>

              <span class="bb-price">
                {{ 'price' | transloco }} :

                @switch (accounttype) {
                @case ("2") { <span>{{product.affiliationprice}}</span> }
                @case ("3") { <span>{{product.pricea}}</span> }
                @case ("4") { <span>{{product.priceb}}</span> }
                @case ("5") { <span>{{product.pricec}}</span> }
                @default { <span>{{product.price}}</span> }
                }

                {{ 'egp' | transloco }}
              </span>

              <span class="bb-text-muted bb-font-semibold">
                {{ 'quantity' | transloco }} :
                {{product.quantity}}
              </span>

            </div>
          </mat-option>
        </mat-autocomplete>

        @if(selectedProductsDetails.length > 0) {
        <div class="bb-field bb-field-full">
          <label class="bb-label">{{ 'Selected Products' | transloco }}</label>

          <div class="bb-table-scroll">
            <table class="bb-table table">
              <thead>
                <tr>
                  <th>{{ 'Product' | transloco }}</th>
                  @if(!isMobile){
                  <th>{{ 'quantity' | transloco }}</th>
                  <th>{{ 'price' | transloco }}</th>
                  }
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of selectedProductsDetails">
                  @if(isMobile){
                  <td class="bb-p-12">
                    <div class="bb-product-title bb-mb-12">{{ item.product.name_ar }}</div>
                    <div class="bb-grid bb-gap-8">
                      <input type="number" placeholder="{{ 'quantity' | transloco }}" formControlName="quantity" min="1"
                        [(ngModel)]="item.quantity" class="bb-input" />
                      <input formControlName="price" placeholder="{{ 'price' | transloco }}" type="number" min="0"
                        [(ngModel)]="item.price" class="bb-input" />
                    </div>
                  </td>
                  }@else{
                  <td>{{ item.product.name_ar }}</td>
                  <td>
                    <input type="number" formControlName="quantity" min="1" [(ngModel)]="item.quantity"
                      class="bb-input" />
                  </td>
                  <td>
                    <input formControlName="price" type="number" min="0" [(ngModel)]="item.price"
                      class="bb-input" />
                  </td>
                  }
                  @if(shouldShowProductRowError(item)) {
                  <td class="bb-p-0" [attr.colspan]="isMobile ? 1 : 3">
                    <div class="bb-field-error">
                      {{ 'Enter a valid quantity and price for this product' | transloco }}
                    </div>
                  </td>
                  }
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        }

        <div class="bb-field bb-field-full">
          <label class="bb-label" for="note">{{ 'note' | transloco }}</label>
          <input class="bb-input" type="text" id="note" formControlName="note" placeholder="{{ 'note' | transloco }}"
            [(ngModel)]="note" [ngClass]="{
              'is-invalid': data.get('note')?.touched && data.get('note')?.invalid,
              'is-valid': data.get('note')?.touched && data.get('note')?.valid
            }" />
        </div>

        <div #formElement class="bb-field-full"></div>

        <div class="bb-field bb-field-full bb-mt-8">
          <button type="submit" class="bb-btn bb-btn-primary bb-w-100" [class.is-disabled]="getMissingRequiredCount() > 0">
            {{ "Submit" | transloco }}
          </button>
        </div>

      </div>
    </form>

  </div>
</section>